import { Box, Chip } from "@mui/material";
import React from "react";

/**
 * Floating chip that displays the current app version in the bottom-right
 * corner of the page. Lives outside the React Router tree so it shows up
 * on every route (including login, landing, error pages).
 *
 * Pair with <AiFab /> / <AiOverlay /> to stack the AI assistant button
 * above the version chip — both share the same z-index and bottom-right
 * anchor.
 */
const VersionChip: React.FC = () => {
  return (
    <Box
      sx={{
        zIndex: 9999999999999,
        position: "fixed",
        bottom: (_) => _.spacing(1),
        right: (_) => _.spacing(1),
      }}
    >
      <Chip
        size="small"
        color="primary"
        label={`v${process.env.REACT_APP_VERSION}`}
      />
    </Box>
  );
};

export default VersionChip;
